/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  addDecoderSizePrefix,
  addEncoderSizePrefix,
  combineCodec,
  fixDecoderSize,
  fixEncoderSize,
  getAddressDecoder,
  getAddressEncoder,
  getArrayDecoder,
  getArrayEncoder,
  getBytesDecoder,
  getBytesEncoder,
  getStructDecoder,
  getStructEncoder,
  getU16Decoder,
  getU16Encoder,
  getU32Decoder,
  getU32Encoder,
  getU64Decoder,
  getU64Encoder,
  getU8Decoder,
  getU8Encoder,
  getUtf8Decoder,
  getUtf8Encoder,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
  type ReadonlyUint8Array,
} from '@solana/kit';
import {
  getFeeBeneficiaryInputDecoder,
  getFeeBeneficiaryInputEncoder,
  type FeeBeneficiaryInput,
  type FeeBeneficiaryInputArgs,
} from '.';

export type InitializeLaunchArgs = {
  namespace: Address;
  launchId: ReadonlyUint8Array;
  baseDecimals: number;
  baseTotalSupply: bigint;
  baseForDistribution: bigint;
  baseForLiquidity: bigint;
  curveVirtualBase: bigint;
  curveVirtualQuote: bigint;
  swapFeeBps: number;
  curveKind: number;
  curveParams: ReadonlyUint8Array;
  allowBuy: number;
  allowSell: number;
  hookFlags: number;
  hookPayload: ReadonlyUint8Array;
  hookCreateRemainingAccountsLen: number;
  migratorInitPayload: ReadonlyUint8Array;
  migratorMigratePayload: ReadonlyUint8Array;
  /**
   * Commitment hash for initialize_launch hook remaining accounts.
   * Computed as hash(u32_len || pubkey_0 || ... || pubkey_n).
   */
  hookCreateRemainingAccountsHash: ReadonlyUint8Array;
  /**
   * Commitment hash for swap/preview hook remaining accounts.
   * Computed as hash(u32_len || pubkey_0 || ... || pubkey_n).
   */
  hookRemainingAccountsHash: ReadonlyUint8Array;
  /**
   * Commitment hash for migrator-init remaining accounts.
   * Computed as hash(u32_len || pubkey_0 || ... || pubkey_n).
   */
  migratorInitRemainingAccountsHash: ReadonlyUint8Array;
  /**
   * Commitment hash for migrator-migrate remaining accounts.
   * Computed as hash(u32_len || pubkey_0 || ... || pubkey_n).
   */
  migratorRemainingAccountsHash: ReadonlyUint8Array;
  /** Token name for on-chain metadata. If empty, metadata creation is skipped. */
  metadataName: string;
  /** Token symbol for on-chain metadata. */
  metadataSymbol: string;
  /** Metadata JSON URI for on-chain metadata. */
  metadataUri: string;
  feeBeneficiaries: Array<FeeBeneficiaryInput>;
};

export type InitializeLaunchArgsArgs = {
  namespace: Address;
  launchId: ReadonlyUint8Array;
  baseDecimals: number;
  baseTotalSupply: number | bigint;
  baseForDistribution: number | bigint;
  baseForLiquidity: number | bigint;
  curveVirtualBase: number | bigint;
  curveVirtualQuote: number | bigint;
  swapFeeBps: number;
  curveKind: number;
  curveParams: ReadonlyUint8Array;
  allowBuy: number;
  allowSell: number;
  hookFlags: number;
  hookPayload: ReadonlyUint8Array;
  hookCreateRemainingAccountsLen: number;
  migratorInitPayload: ReadonlyUint8Array;
  migratorMigratePayload: ReadonlyUint8Array;
  /**
   * Commitment hash for initialize_launch hook remaining accounts.
   * Computed as hash(u32_len || pubkey_0 || ... || pubkey_n).
   */
  hookCreateRemainingAccountsHash: ReadonlyUint8Array;
  /**
   * Commitment hash for swap/preview hook remaining accounts.
   * Computed as hash(u32_len || pubkey_0 || ... || pubkey_n).
   */
  hookRemainingAccountsHash: ReadonlyUint8Array;
  /**
   * Commitment hash for migrator-init remaining accounts.
   * Computed as hash(u32_len || pubkey_0 || ... || pubkey_n).
   */
  migratorInitRemainingAccountsHash: ReadonlyUint8Array;
  /**
   * Commitment hash for migrator-migrate remaining accounts.
   * Computed as hash(u32_len || pubkey_0 || ... || pubkey_n).
   */
  migratorRemainingAccountsHash: ReadonlyUint8Array;
  /** Token name for on-chain metadata. If empty, metadata creation is skipped. */
  metadataName: string;
  /** Token symbol for on-chain metadata. */
  metadataSymbol: string;
  /** Metadata JSON URI for on-chain metadata. */
  metadataUri: string;
  feeBeneficiaries: Array<FeeBeneficiaryInputArgs>;
};

export function getInitializeLaunchArgsEncoder(): Encoder<InitializeLaunchArgsArgs> {
  return getStructEncoder([
    ['namespace', getAddressEncoder()],
    ['launchId', fixEncoderSize(getBytesEncoder(), 32)],
    ['baseDecimals', getU8Encoder()],
    ['baseTotalSupply', getU64Encoder()],
    ['baseForDistribution', getU64Encoder()],
    ['baseForLiquidity', getU64Encoder()],
    ['curveVirtualBase', getU64Encoder()],
    ['curveVirtualQuote', getU64Encoder()],
    ['swapFeeBps', getU16Encoder()],
    ['curveKind', getU8Encoder()],
    ['curveParams', addEncoderSizePrefix(getBytesEncoder(), getU32Encoder())],
    ['allowBuy', getU8Encoder()],
    ['allowSell', getU8Encoder()],
    ['hookFlags', getU32Encoder()],
    ['hookPayload', addEncoderSizePrefix(getBytesEncoder(), getU32Encoder())],
    ['hookCreateRemainingAccountsLen', getU32Encoder()],
    [
      'migratorInitPayload',
      addEncoderSizePrefix(getBytesEncoder(), getU32Encoder()),
    ],
    [
      'migratorMigratePayload',
      addEncoderSizePrefix(getBytesEncoder(), getU32Encoder()),
    ],
    ['hookCreateRemainingAccountsHash', fixEncoderSize(getBytesEncoder(), 32)],
    ['hookRemainingAccountsHash', fixEncoderSize(getBytesEncoder(), 32)],
    [
      'migratorInitRemainingAccountsHash',
      fixEncoderSize(getBytesEncoder(), 32),
    ],
    ['migratorRemainingAccountsHash', fixEncoderSize(getBytesEncoder(), 32)],
    ['metadataName', addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
    ['metadataSymbol', addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
    ['metadataUri', addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
    ['feeBeneficiaries', getArrayEncoder(getFeeBeneficiaryInputEncoder())],
  ]);
}

export function getInitializeLaunchArgsDecoder(): Decoder<InitializeLaunchArgs> {
  return getStructDecoder([
    ['namespace', getAddressDecoder()],
    ['launchId', fixDecoderSize(getBytesDecoder(), 32)],
    ['baseDecimals', getU8Decoder()],
    ['baseTotalSupply', getU64Decoder()],
    ['baseForDistribution', getU64Decoder()],
    ['baseForLiquidity', getU64Decoder()],
    ['curveVirtualBase', getU64Decoder()],
    ['curveVirtualQuote', getU64Decoder()],
    ['swapFeeBps', getU16Decoder()],
    ['curveKind', getU8Decoder()],
    ['curveParams', addDecoderSizePrefix(getBytesDecoder(), getU32Decoder())],
    ['allowBuy', getU8Decoder()],
    ['allowSell', getU8Decoder()],
    ['hookFlags', getU32Decoder()],
    ['hookPayload', addDecoderSizePrefix(getBytesDecoder(), getU32Decoder())],
    ['hookCreateRemainingAccountsLen', getU32Decoder()],
    [
      'migratorInitPayload',
      addDecoderSizePrefix(getBytesDecoder(), getU32Decoder()),
    ],
    [
      'migratorMigratePayload',
      addDecoderSizePrefix(getBytesDecoder(), getU32Decoder()),
    ],
    ['hookCreateRemainingAccountsHash', fixDecoderSize(getBytesDecoder(), 32)],
    ['hookRemainingAccountsHash', fixDecoderSize(getBytesDecoder(), 32)],
    [
      'migratorInitRemainingAccountsHash',
      fixDecoderSize(getBytesDecoder(), 32),
    ],
    ['migratorRemainingAccountsHash', fixDecoderSize(getBytesDecoder(), 32)],
    ['metadataName', addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
    ['metadataSymbol', addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
    ['metadataUri', addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
    ['feeBeneficiaries', getArrayDecoder(getFeeBeneficiaryInputDecoder())],
  ]);
}

export function getInitializeLaunchArgsCodec(): Codec<
  InitializeLaunchArgsArgs,
  InitializeLaunchArgs
> {
  return combineCodec(
    getInitializeLaunchArgsEncoder(),
    getInitializeLaunchArgsDecoder(),
  );
}
